import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoaderComponent } from './shared/ui/global-loader.component';
import { ApiBusyComponent } from './shared/ui/api-busy.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalLoaderComponent, ApiBusyComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
